export const DE = 'de';
export const EN = 'en';
export const ES = 'es';
export const FR = 'fr';
export const JA = 'ja';
export const IT = 'it';
export const NL = 'nl';
export const PT_BR = 'pt-br';
export const FI = 'fi';
export const PL = 'pl';
export const SV = 'sv';
export const PT = 'pt';